/**
 * @fileoverview POST handler for the "/apps/:app_group_id/products_settings_create" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdProductsSettingsCreateCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdProductsSettingsCreateProps,
  AppsAppGroupIdProductsSettingsCreateResult,
} from "./types";

export const postAppsAppGroupIdProductsSettingsCreate = reactQueryMutationAdapter(
  appsAppGroupIdProductsSettingsCreateCacheKeys,
  (props: PostAppsAppGroupIdProductsSettingsCreateProps): Promise<AppsAppGroupIdProductsSettingsCreateResult> => {
    return fetch(`/apps/${props.appGroupId}/products_settings_create`, "POST", props);
  }
);
